import React from "react";
import { useSessionStore } from "../stores/UserStore";

const LogoMini = ({ ...props }) => {
  const reseller = useSessionStore((s) => s.reseller);

  if (reseller.name !== "Magileads") {
    return (
      <img
        src={reseller.logo_menu_url}
        width={"100%"}
        height={"100%"}
        style={{
          objectFit: "contain"
        }}
        {...props}
      />
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 209 94"
      fill="none"
      width={"100%"}
      height={"100%"}
      {...props}
    >
      <path
        d="M180.711 5.77192C177.66 2.23382 173.181 0 168.188 0C163.853 0 159.905 1.68446 156.943 4.4447L145.632 16.0505C140.29 21.5972 140.326 30.4961 145.738 35.9985C151.186 41.537 160.019 41.537 165.467 35.9985C166.133 35.3208 166.718 34.5917 167.222 33.8237C167.559 33.3083 167.907 33.0743 168.505 33.0743C169.103 33.0743 169.457 33.1823 169.958 33.7572L173.713 37.8094C174.198 38.3496 175.909 40.1506 176.309 40.5576L177.623 41.8937C183.067 47.4281 183.067 56.4011 177.623 61.9355C172.955 66.6815 165.799 67.3576 160.422 63.9637C159.987 63.7908 159.321 63.3143 158.34 62.4164L155.313 59.4981L102.207 5.50866C99.1604 2.08064 94.6805 0.000208464 89.7781 0.000208682C85.4376 0.000208874 81.4637 1.60187 78.5 4.36818L65.6106 16.9261C60.3366 22.5617 60.508 31.5371 65.9492 37.0688C70.8437 42.0449 78.4319 42.6135 83.9421 38.7746C83.9178 38.7718 83.9662 38.7777 83.9421 38.7746C85.3695 37.8071 86.3325 36.4024 87.2637 35.1474C88.4346 33.5692 89.4401 32.2139 90.8511 32.2139C92.1382 32.2139 92.9692 32.7956 93.6158 33.4L93.6224 33.3984L93.7496 33.5277C93.8623 33.6374 93.9696 33.7464 94.0731 33.8516C94.0861 33.8649 94.0983 33.8789 94.109 33.8931L137.134 77.9798L139.733 80.6227C155.575 96.7283 181.26 96.7283 197.102 80.6227C212.143 65.3316 212.934 40.99 199.414 24.7865L199.016 24.3816C198.406 23.6707 197.768 22.976 197.102 22.299L194.435 19.7246L180.711 5.77192Z"
        fill="url(#paint0_linear_556_213)"
      />
      <path
        d="M23.3075 5.47583C20.2754 2.37659 17.1701 0.0892488 12.8894 0.0892488C5.77078 0.0892488 0 5.95606 0 13.1931C0 17.5452 3.3942 21.6774 5.29884 23.7849L60.5301 79.9352C62.5143 82.1365 65.1848 84.9125 67.3832 86.6864C73.4621 91.2812 80.9945 94 89.1515 94C95.5658 94 101.594 92.3189 106.833 89.3664C108.401 88.6782 109.877 87.6716 111.171 86.3559C116.365 81.0762 116.653 72.819 111.455 67.5339C106.585 63.3398 98.5216 64.7802 94.4536 65.9787C89.8507 67.6165 84.6076 66.8623 80.5944 63.716L77.8984 60.9751L77.8049 60.8505L77.7875 60.8624L23.3075 5.47583Z"
        fill="url(#paint1_linear_556_213)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_556_213"
          x1="1.53331"
          y1="84.2473"
          x2="79.1898"
          y2="151.446"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5746E2" />
          <stop offset="0.5" stopColor="#8963F4" />
          <stop offset="1" stopColor="#9F4AF0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_556_213"
          x1="1.53331"
          y1="84.2473"
          x2="79.1898"
          y2="151.446"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5746E2" />
          <stop offset="0.5" stopColor="#8963F4" />
          <stop offset="1" stopColor="#9F4AF0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LogoMini;
